import {
  type SessionTimeoutAction,
  type ShowSignOutBoxData,
  HNeventSetOnShowSignoutbox,
} from '@helsenorge/framework-utils/web-component/events';

export const dispatchSetSessionTimeoutFn = (fn: (data: ShowSignOutBoxData) => SessionTimeoutAction): void => {
  HNeventSetOnShowSignoutbox(fn);
};
